export default "__VITE_ASSET__7bc5930f__"